/// <reference types="svelte" />

import { SomaCoreClient } from '../core/client'
import type { UseSomaOptions, UseSomaReturn, SomaMessage } from '../types'

export function useSomaSvelte(options: UseSomaOptions): UseSomaReturn {
  let messages = $state<SomaMessage[]>([])
  let isConnected = $state(false)
  let isStreaming = $state(false)
  let streamContent = $state('')

  const client = new SomaCoreClient(options)

  $effect(() => {
    client.updateOptions(options)
    const unsubscribe = client.subscribe((state) => {
      messages = state.messages
      isConnected = state.isConnected
      isStreaming = state.isStreaming
      streamContent = state.streamContent
    })
    client.connect()
    return () => {
      unsubscribe()
      client.disconnect()
    }
  })

  return {
    get messages() {
      return messages
    },
    get isConnected() {
      return isConnected
    },
    get isStreaming() {
      return isStreaming
    },
    get streamContent() {
      return streamContent
    },
    send: (text: string) => client.send(text),
    cancel: () => client.cancel(),
    reconnect: () => client.reconnect(),
  }
}
